const EQUIPMENTS = {
  "Général": [
    "Climatisation",
    "Télévision",
    "Balcon",
    "Vue mer"
  ],
  "Internet": [
    "WiFi gratuit"
  ],
  "Parking": [
    "Parking gratuit",
    "Parking privé"
  ],
  "Bien-être": [
    "Piscine",
    "Spa",
    "Salle de sport"
  ],
  "Restauration": [
    "Restaurant",
    "Bar",
    "Petit-déjeuner"
  ]
};

export default function EquipmentsStep({ formData, setFormData }) {

  const toggle = (item) => {
    setFormData(prev => ({
      ...prev,
      equipments: prev.equipments.includes(item)
        ? prev.equipments.filter(e => e !== item)
        : [...prev.equipments, item]
    }));
  };

  return (
    <div className="space-y-8">

      {/* TITLE */}
      <div>
        <h2 className="text-2xl font-semibold">
          Équipements
        </h2>
        <p className="text-gray-500 mt-1">
          Sélectionnez les équipements disponibles dans votre établissement
        </p>
      </div>

      {/* CATEGORIES */}
      <div className="space-y-6">

        {Object.entries(EQUIPMENTS).map(([category, items]) => (
          <div key={category}>

            {/* CATEGORY TITLE */}
            <h3 className="font-semibold mb-3 text-lg">
              {category}
            </h3>

            {/* ITEMS */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">

              {items.map(item => {
                const isActive = formData.equipments.includes(item);

                return (
                  <div
                    key={item}
                    onClick={() => toggle(item)}
                    className={`cursor-pointer px-4 py-3 rounded-xl border transition text-sm
                      ${
                        isActive
                          ? "bg-green-50 border-green-500 text-green-700"
                          : "bg-white border-gray-200 hover:border-gray-400"
                      }
                    `}
                  >
                    {item}
                  </div>
                );
              })}

            </div>

          </div>
        ))}

      </div>

      {/* SELECTED COUNT */}
      {formData.equipments.length > 0 && (
        <div className="text-sm text-gray-500">
          {formData.equipments.length} équipement(s) sélectionné(s)
        </div>
      )}

    </div>
  );
}